<template>
  <div v-if="promoIsActive  &&  !hidePopUp">
    <div v-if="$vuetify.breakpoint.mdAndUp">
      <div class="foot">
        <v-row>
          <v-col md="4">
            <v-img
              v-if="false"
              class="img"
              contain
              src="/gimc/storage/assets/png/pere-noel.png"
            ></v-img>
          </v-col>
          <v-col md="4" class="text-center mb-n3">
            <p style="color: white" v-html="msg"></p>
            <br/>
          </v-col>
          <v-col md="4" class="mt-4">
            <div class="text-center">
              <v-btn v-if="!isPromoAccepted" class="mr-5" @click="accept" small style="opacity: 0.8">
                J'en profite
              </v-btn>
              <v-btn v-if="!isPromoAccepted" @click="hidePopUp = true" small style="opacity: 0.8">
                Fermer
              </v-btn>
              <v-btn text v-if="isPromoAccepted" @click="hidePopUp = true" small style="opacity: 0.8">
                X
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
    <div v-if="$vuetify.breakpoint.smAndDown">
      <div class="foot">
        <p class="text-center mt-5 pb-5 mr-3 ml-3" style="color: white" v-html="msg">

        </p>
        <div class="mt-5 mb-5 text-center">
          <v-btn v-if="!isPromoAccepted" class="mr-5" @click="accept" small style="opacity: 0.8" >
            J'en profite
          </v-btn>
          <v-btn v-if="!isPromoAccepted" @click="hidePopUp = true" small style="opacity: 0.8">
            Fermer
          </v-btn>
          <v-btn text v-if="isPromoAccepted" @click="hidePopUp = true" small style="opacity: 0.8">
            X
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data: () => ({
    hidePopUp: false,
    isPromoAccepted: false
  }),
  computed: {
    ...mapGetters('strapiv2', ['promoIsActive', 'promo']),
    msg () {
      return this.isPromoAccepted ? this.promo.messageWithCode : this.promo.messageAdvert
    }
  },
  methods: {
    accept () {
      if (this.promo.messageWithCode[0] === '/') {
        this.$router.push(this.promo.messageWithCode)
        this.hidePopUp = true
      } else {
        this.isPromoAccepted = true
        this.$router.push('/nos-offres')
      }
    }
  }
}
</script>

<style scoped>
.foot {
  background: #508500;
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 10;
}
.img {
  position: fixed;
  bottom: 0;
  left: 10%;
  width: 20%;
  height: 20%;
}

</style>